import { isEqual, sortBy } from 'lodash';

export const isArraysHaveSameElements = (a: any[], b: any[]) => {
  return isEqual(sortBy(a), sortBy(b));
};
